//
// # (GUI Tree) Parent
//

import type { Child } from "./child";
import type { Xform } from "GenAlphaModel";
import type { RenderContentBase } from "../content/base_render";

// Generic over the concrete render-tier root type (`Root`), defaulting to the
// shared base. Content-specific entity trees narrow it (e.g. layout entities use
// `Parent<LayoutRender>`) so `entity.root` is typed as the concrete content
// without a cast. `Root` appears only in output position (`root`), so a
// `Parent<Sub>` is assignable to a `Parent<RenderContentBase>` — a subtree can
// still parent shared entities that only need the base.
export interface Parent<Root extends RenderContentBase = RenderContentBase> {
  root: Root; // Root content (render tier — see base_render.ts)
  parent: Parent<Root> | null; // Parent Container. Null for the top-level Content.
  xform: Xform; // Transform
  // Child nodes. `delete` is part of the contract because a child that
  // registers itself in its constructor has no other way to detach: `Dot`s in
  // particular are rebuilt wholesale on every wire edit, and without this each
  // generation stayed in the tree forever.
  children: { add(child: Child): unknown; delete(child: Child): unknown };
  highlighted: boolean; // Highlighted state
}
